import { type Section } from "~/api/types";
import { DocumentVersionStatus } from "~/config/types";

export const getDraftDocumentsNotUsingLatestSection = (section: Section) => {
  if (section.sectionVersions.length <= 1) {
    return null;
  }

  // Avoid checking latest section version
  const nonLatestVersions = section.sectionVersions
    .toSorted(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )
    .slice(1);

  const draftDocuments = nonLatestVersions.flatMap((sv) =>
    sv.usedInDocumentVersions.filter(
      (dv) => dv.status === DocumentVersionStatus.draft,
    ),
  );

  return draftDocuments.length > 0 ? draftDocuments : null;
};
